<template>
    <div class="loading-preview preview-button">
        <div class="generation-spinner">
            <span
                v-loading="true"
                class="preview-spinner"
            >
            </span>
        </div>
        <p
            class="loading-title"
            :style="{'font-size': fontSize, 'margin': margin}"
        >Preview will start soon</p>
        <button
            class="preview-cancel"
            v-if="canCancelPreviewGeneration"
            @click="cancelPreview('cancel')"
        >
            x Cancel preview
        </button>
    </div>
</template>

<script>
    import PreviewStepMixin from '@/components/Mixins/preview-step-mixin.vue';
    export default{
        name: 'Loading',
        mixins: [PreviewStepMixin],
        props: {
            canCancelPreviewGeneration: {
                type: Boolean,
                default: true,
            }
        },
        components: {
        },
        data(){
            return{

            };
        },
        mounted(){
            this.watchModelStatus(this.creationRequest, 'COMPLETED', 'FAILED')
            .then((response)=>{
                this.$emit('onCreationRequestCompleted', response);
                this.changeStep(3);
            })
            .catch((response)=>{
                this.$emit('setErrorVerboseStatus', response.verbose_status)
                this.changeStep(2);
            });
        },
        computed : {

        },
        methods: {

        },
    };
</script>

<style>
.generation-spinner{
    width: 42px;
    height: 42px;
    position: relative;
    transform: translate(-50%);
}
.preview-spinner .el-loading-spinner{
    margin-top: -5px;
}
.loading-wait{
    margin: 0;
}


</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewStep/Loading/index.vue